import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";

import type { FormEvent } from "react";
import type { CheckboxProps } from "semantic-ui-react";

type RecallHeaderProps = {
  title: string;
  selectOnly: boolean;
  showColumnNames: boolean;
  allOptionSelected?: boolean;
  isAllOptionPreselected?: boolean;
  toggleAllOption?: () => void;
  onSelectAllRecalls?: (checked: boolean) => void;
};

export const RecallHeader = ({
  title,
  selectOnly,
  showColumnNames,
  allOptionSelected,
  isAllOptionPreselected,
  toggleAllOption,
  onSelectAllRecalls
}: RecallHeaderProps) => {
  const { t } = useTranslation();

  const handleAllCheckboxSelect = (_: FormEvent<HTMLInputElement>, { checked }: CheckboxProps) => {
    onSelectAllRecalls?.(!!checked);
    toggleAllOption?.();
  };

  return (
    <div className={`OpenRecalls-title OpenRecalls-title-layout-${selectOnly ? "select" : "convert"}`}>
      <div className="OpenRecalls-headerGroup">
        {selectOnly && (
          <Checkbox defaultChecked={isAllOptionPreselected} disabled={isAllOptionPreselected} checked={allOptionSelected} onChange={handleAllCheckboxSelect} />
        )}
        <span className="OpenRecalls-title-text">{title}</span>
      </div>

      {showColumnNames && (
        <>
          {!selectOnly && <span>{t("v8_status", "Status")}</span>}
          <span>{t("v8_close_date", "Close Date")}</span>
          {!selectOnly && <div className="OpenRecalls-filler" />}
        </>
      )}
    </div>
  );
};
